var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCake = function SvgCake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 9.55a.638.638 0 00-.012-.109c-.001-.01-.005-.02-.008-.029a.525.525 0 00-.023-.073c-.005-.014-.011-.025-.017-.037a.457.457 0 00-.056-.094.633.633 0 00-.05-.058.525.525 0 00-.107-.092s0-.002-.002-.002L9.748.354a.64.64 0 00-.594-.056C3.813 2.523.75 5.898.75 9.558v7.59c0 .333.279.602.622.602h21.256c.344 0 .622-.27.622-.602v-7.59-.007zm-1.243 2.773H1.994V10.16h20.013v2.163zM1.994 16.544v-2.05h20.013v2.05H1.994z",
    fill: "#1F1F1F"
  })));
};

export default SvgCake;